import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { NewTeamModalContent } from './NewTeamModalContent';

export const NewTeamModal = () => {
  return (
    <AppModal modalName={Modals.NEW_TEAM} maxWidth="xs">
      <NewTeamModalContent />
    </AppModal>
  );
};
